export default class priceRangeSlider {

    constructor() {
        document.querySelectorAll('.input-range').forEach(block => {
            let lowerSlider = block.querySelector('.input-range__input--min')
            let upperSlider = block.querySelector('.input-range__input--max')
    
            let lowerVal = parseFloat(lowerSlider.value)
            let upperVal = parseFloat(upperSlider.value)
    
            let lowerOutput = block.querySelector('.input-range__output--min')
            let upperOutput = block.querySelector('.input-range__output--max')
            
            console.log(block)

            upperSlider.oninput = function () {
                lowerVal = parseFloat(lowerSlider.value);
                upperVal = parseFloat(upperSlider.value);
            
                if (upperVal < lowerVal + 4) {
                    lowerSlider.value = upperVal - 4;
                    if (lowerVal == lowerSlider.min) {
                        upperSlider.value = 4;
                        lowerOutput.value = 4;
                    }
                }
                upperOutput.value=this.value
                lowerOutput.value=lowerSlider.value
            };
            
            lowerSlider.oninput = function () {
                lowerVal = parseFloat(lowerSlider.value);
                upperVal = parseFloat(upperSlider.value);
                if (lowerVal > upperVal - 4) {
                    upperSlider.value = lowerVal + 4;
                    if (upperVal == upperSlider.max) {
                        lowerSlider.value = parseFloat(upperSlider.max) - 4;
                        upperOutput.value = parseFloat(upperSlider.max) - 4;
                    }
                }
                lowerOutput.value=this.value
                upperOutput.value=upperSlider.value
            };
        })
    }

}